import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve relative /api/static/... paths against the configured backend.
export const resolveAssetUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const api = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

export const clearAuthToken = () => {
  delete api.defaults.headers.common["Authorization"];
};

// Restore token on module load
const stored = typeof window !== "undefined" ? localStorage.getItem("faith_athletic_token") : null;
if (stored) setAuthToken(stored);
